import { useErrorHandler } from './useErrorHandler';

export const useConsoleErrorPhoneOverride = () => {
  const { handleConsoleErrorOverride } = useErrorHandler();

  /**
   * Override console error messages for better readability or to remove PII.
   *
   * Each override requires:
   *  - originalMessage: The exact error text (or part of it) to match.
   *  - replacementMessage: The message you want to display instead.
   */
  const originalMessage = '[react-phone-number-input] Expected the initial `value` to be a E.164 phone number';
  const replacementMessage = '[react-phone-number-input] Expected the initial `value` to be a E.164 phone number';

  handleConsoleErrorOverride({
    [originalMessage]: replacementMessage,
  });
};
